import { Component, EventEmitter, OnInit, Input, Output, ViewChild, VERSION } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ADPResourceService, CustomFormControl } from 'digital-core';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { combineLatest, concatMap, filter, tap } from 'rxjs';
import { AccountService } from 'src/app/core/services/account.service';
import { DeviceInventoryService } from 'src/app/core/services/device-inventory.service';
import { DeviceDto } from 'src/app/core/services/device-inventory/device.dto';
import { InventoryInfoDto } from 'src/app/core/services/device-inventory/inventory-info.dto';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UtilityService } from 'src/app/core/services/utility.service';
import { PghUserDeviceBase } from 'src/app/shared/device/pgh-user-device';
import { SelectedDeviceService } from 'src/app/shared/device/selected-device.service';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { buildDeviceDisplayName } from 'src/app/shared/device/device-display-name.pipe';

@Component({
  selector: 'pgh-imei-questionnaire',
  templateUrl: './imei-questionnaire.component.html',
  styleUrls: ['./imei-questionnaire.component.scss']
})
export class ImeiQuestionnaireComponent implements OnInit {
  @Output() nextEvent = new EventEmitter<boolean>()
  @Output() backEvent = new EventEmitter();
  @Output() viewIMEIInfo = new EventEmitter();
  @Input() public preSelectedDevice?: PghUserDeviceBase;
  @Input() public isOnboardingFlow?:boolean =  false;
  @Input() public deviceTypeCode:string;

  public preHeaderTextContext?: { device:string };

  programCode: string;
  device: PghUserDeviceBase;
  hylaLink: string;
  private deviceInventoryInfo?: InventoryInfoDto;
  private diagnosticDevices?: DeviceDto[];

  public elementType:NgxQrcodeElementTypes;
  public value:string;
  public correctionLevel:NgxQrcodeErrorCorrectionLevels;

  public imeiQuestionnaireForm: UntypedFormGroup;

  public title:string='';

  constructor(
    public resourceService: ADPResourceService,
    private deviceInventoryService: DeviceInventoryService,
    private selectedDeviceService: SelectedDeviceService,
    private utilityServce: UtilityService,
    private accountService: AccountService,
    private loggedInUserSettings: LoggedInUserSettings,
  ) { }


  ngOnInit(): void {

    // TODO: Need to get device type passed into this component during onboarding flow, no
    // selected device in onboarding flow
    if(!this.isOnboardingFlow){
      const selDevice = this.selectedDeviceService.getSelectedDevice();
      this.preHeaderTextContext = { device: buildDeviceDisplayName(selDevice)};
    }

    const headerText = this.resourceService.getPortalLabel("RegisterDiagnosticDevice_Imei_Questionnaire_Header").Value;
    let deviceTypeText:string = '';

    if(this.deviceTypeCode === 'SMPH'){
        deviceTypeText = this.resourceService.getPortalLabel("RegisterDiagnosticDevice_Imei_Questionnaire_Phone_Title").Value;
    }else if(this.deviceTypeCode === 'TABL'){
        deviceTypeText = this.resourceService.getPortalLabel("RegisterDiagnosticDevice_Imei_Questionnaire_Tablet_Title").Value;;
    }else if(this.deviceTypeCode === 'SMAR'){
        deviceTypeText = this.resourceService.getPortalLabel("RegisterDiagnosticDevice_Imei_Questionnaire_Smartwatch_Title").Value;;
    }

    this.title = headerText.replace(/{{deviceType}}/g, deviceTypeText);

    this.imeiQuestionnaireForm = new FormGroup({
      selectedConfirmation: new FormControl('', Validators.required)
    });

  }

  handleViewIMEIInfo(){
    this.viewIMEIInfo.emit();
  }

  public handleNextEvent() {

    const selectedConfirmation = [this.imeiQuestionnaireForm.get('selectedConfirmation').value];

    if (this.imeiQuestionnaireForm.valid)
     {

      let deviceHasImei:boolean = true;

      if(selectedConfirmation[0] === 'NO'){
        deviceHasImei = false;
      }
      else if(selectedConfirmation[0] === 'YES'){
        deviceHasImei = true;
      }

      this.nextEvent.emit(deviceHasImei);
    }
  }


}
